import { useEffect, useState } from "react";
import { useAppSelector } from "redux-share/hooks";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { fetchFile, getStyleForTime } from "redux-share/actions/progressbar.actions";
import { shallowEqual } from "react-redux";
import { memo } from "react";

const Tooltip = () => {
    const { details } = useAppSelector(({ videoData: { details } }) => ({ details }), shallowEqual);
    const { tooltipTime } = useAppSelector(({ controller: { tooltipTime, activeElements } }) => ({ tooltipTime, activeElements }), shallowEqual);

    const cache: any = {};
    const [vttPool, setVttPool] = useState<any>(undefined);
    const [vttUrl, setVttUrl] = useState<string | undefined>(conditions(ConditionName.isTouchScreen) ? details.vtt_mobile : details.vtt);

    useEffect(() => {
        setVttUrl(conditions(ConditionName.isVttFitHeight) ? details.vtt_mobile : details.vtt);
    }, [details.vtt, details.vtt_mobile, conditions(ConditionName.isVttFitHeight)]);

    useEffect(() => {
        if (!!vttUrl) fetchFile(conditions(ConditionName.isVttFitHeight) ? details.vtt_mobile! : details.vtt!, setVttPool);
    }, [vttUrl]);

    return conditions(ConditionName.isActiveElements) ? (
        <div
            className={`pl-flex pl-flex-col pl-progressTooltip pl-absolute pl-bottom-[200%] pl-px-[10px] pl-py-[5px] pl-mr-[-25px] pl-mb-[25px] pl-text-white pl-text-[14px] ${
                vttUrl && !!vttPool ? "" : "pl-bg-z-gray-700"
            } pl-rounded-[6px] pl-opacity-0`}
        >
            {vttUrl && !!vttPool && (
                <div className="pl-flex-1 pl-border pl-border-white pl-rounded-[8px]">
                    <div className="pl-rounded-[8px]" style={getStyleForTime(tooltipTime, vttPool, cache)} />
                </div>
            )}
            <div className="pl-flex pl-items-center pl-justify-center pl-progressTimeTooltip pl-text-white !pl-opacity-100" />
        </div>
    ) : (
        <></>
    );
};

export default memo(Tooltip);
